import { loadStripe, type Stripe } from '@stripe/stripe-js';

/**
 * Stripe.js loader - singleton across the app. ``loadStripe`` returns a
 * Promise that resolves once Stripe.js has been fetched and parsed; we
 * cache it at module scope so subsequent ``<Elements>`` mounts don't
 * re-download the script.
 */
const PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  // Surface the missing config loudly during dev - the PaymentElement
  // will fail with an opaque error otherwise.
  // eslint-disable-next-line no-console
  console.warn(
    '[StripeProvider] VITE_STRIPE_PUBLISHABLE_KEY is not set. ' +
      'Add it to apps/web/.env to enable embedded checkout.'
  );
}

const stripePromise: Promise<Stripe | null> = PUBLISHABLE_KEY
  ? loadStripe(PUBLISHABLE_KEY)
  : Promise.resolve(null);

/**
 * The same Stripe.js instance, for flows that confirm a PaymentIntent without
 * mounting an Element — the Change-plan dialog's 3DS step, whose card is
 * already on file. Resolves to null when no publishable key is configured.
 */
export function getStripe(): Promise<Stripe | null> {
  return stripePromise;
}
